import React from 'react';
import { Helmet } from 'react-helmet';
import { CookiesContainer, CookiesContent } from './estilosCookies';



function CookiesPolicy() {
  return (
    <CookiesContainer>
      <Helmet>
        <title>Política de Cookies - JuanFra Hernández</title>
        <meta name="description" content="Política de cookies de JuanFra Hernández" />
        <link rel="canonical" href="https://juanfrahernandez.es/aviso-legal" />
      </Helmet>
      
      <CookiesContent>
        <h1>Política de Cookies</h1>
        
        <p>Última actualización: {new Date().toLocaleDateString()}</p>
        
        <p>Esta Política de Cookies explica qué son las cookies y cómo las utilizamos. Debes leer esta política para entender qué son las cookies, cómo las usamos, los tipos de cookies que utilizamos, la información que recopilamos usando cookies y cómo se utiliza esa información, y cómo controlar las preferencias de cookies.</p>
        
        <h2>¿Qué son las cookies?</h2>
        
        <p>Las cookies son pequeños archivos de texto que se almacenan en tu ordenador o dispositivo móvil cuando visitas un sitio web. Las cookies son ampliamente utilizadas por los propietarios de sitios web para hacer que sus sitios web funcionen, o funcionen de manera más eficiente, así como para proporcionar información de informes.</p>
        
        <p>Las cookies establecidas por el propietario del sitio web (en este caso, JuanFra Hernández) se denominan "cookies propias". Las cookies establecidas por partes distintas del propietario del sitio web se denominan "cookies de terceros". Las cookies de terceros permiten que se proporcionen funciones o características de terceros en o a través del sitio web (por ejemplo, publicidad, contenido interactivo y análisis).</p>
        
        <h2>¿Cómo utilizamos las cookies?</h2>
        
        <p>Utilizamos cookies por varias razones que se detallan a continuación. Desafortunadamente, en la mayoría de los casos, no existen opciones estándar de la industria para deshabilitar las cookies sin deshabilitar completamente la funcionalidad y las características que agregan a este sitio. Se recomienda que dejes activadas todas las cookies si no estás seguro de si las necesitas o no, en caso de que se utilicen para proporcionar un servicio que utilizas.</p>
        
        <h2>Tipos de cookies que utilizamos</h2>
        
        <table>
          <thead>
            <tr>
              <th>Tipo de Cookie</th>
              <th>Descripción</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Cookies Necesarias</td>
              <td>Estas cookies son esenciales para que puedas utilizar las características disponibles en nuestro sitio web. Sin estas cookies, no podemos proporcionar ciertas funcionalidades del sitio web.</td>
            </tr>
            <tr>
              <td>Cookies de Funcionalidad</td>
              <td>Estas cookies nos permiten recordar las elecciones que haces cuando utilizas nuestro sitio web, como recordar tus preferencias de idioma o tus datos de inicio de sesión. El propósito de estas cookies es proporcionarte una experiencia más personal.</td>
            </tr>
            <tr>
              <td>Cookies de Análisis</td>
              <td>Estas cookies nos permiten contar las visitas y las fuentes de tráfico para que podamos medir y mejorar el rendimiento de nuestro sitio. Nos ayudan a saber qué páginas son las más y menos populares y ver cómo se mueven los visitantes por el sitio.</td>
            </tr>
          </tbody>
        </table>
        
        <h2>Tus opciones con respecto a las cookies</h2>
        
        <p>Si prefieres restringir, bloquear o eliminar cookies de nuestro sitio web, puedes utilizar tu navegador web para hacerlo. Cada navegador es diferente, así que consulta el menú de "Ayuda" de tu navegador para aprender la forma correcta de modificar tus cookies.</p>
        
        <p>Si eliges rechazar las cookies, es posible que no puedas utilizar completamente todas las funcionalidades de nuestro sitio web.</p>
        
        <h2>Contacto</h2>
        
        <p>Si tienes alguna pregunta sobre esta Política de Cookies, puedes contactarnos:</p>
        
        <ul>
          <li>Por correo electrónico: info@juanfrahernandez.es</li>
          <li>Por teléfono: +34 604 831 012</li>
          <li>Por correo postal: Calle San Benito 3, 04738 Vicar</li>
        </ul>
      </CookiesContent>
    </CookiesContainer>
  );
}

export default CookiesPolicy;